import { useContext, useState, useEffect, useCallback } from 'react'

// api references
import { apiClient } from 'utils/api/apiClient'

// Soft UI Dashboard PRO React components
import DashboardLayout from 'components/LayoutContainers/DashboardLayout'

// Data
import { selectData } from 'layouts/onboarding'
import { IntakeContext } from 'context/IntakeContext'

// Popup
import { toast } from 'react-toastify'
import { useFormDebounce } from 'hooks/useFormDebounce'
import { Box, Grid, Typography, Button } from '@mui/material'
import LoadingButton from 'components/LoadingButton'

import ActualBarChart from 'components/graphs/SP500'
import SequenceReturn from 'components/graphs/SequenceReturn'
import NewTsp from 'layouts/authenticated/pages/tsp/NewTsp'

const GraphsCheck = () => {
  const {
    intakeState,
    updateIntakeStateAtKey,
    updateUser,
    userTasks,
    currentErrors,
    isAdmin,
  } = useContext(IntakeContext)

  const { updateIntakeStateAndSubmit, loading } = useFormDebounce()

  const [mode, setMode] = useState('none')
  const [rate, setRate] = useState(5)

  return (
    <DashboardLayout>
      <Box
        px={{
          xs: 4,
          sm: 4,
          md: 4,
          lg: 6,
          xl: 6,
          xxl: 6,
          test: 6,
          xl3: 6,
        }}
      >
        <Grid container spacing={2} p={2}>
          <Grid item xs={12} mb={1} mt={4}>
            <Typography
              variant="h1"
              fontWeight="600"
              fontSize="28px"
              textAlign="left"
              color="#262627"
            >
              Graphs Check
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography textAlign="left" color="#262627">
              Graphs to review
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h3">Default</Typography>
            <ActualBarChart strategy={'none'} rate={'none'} />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h3">Cap Rate 8%</Typography>
            <ActualBarChart strategy={'capRate'} rate={8} />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h3">Fixed Rate 5%</Typography>
            <ActualBarChart strategy={'fixedRate'} rate={5} />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h3">Trigger 7%</Typography>
            <ActualBarChart strategy={'trigger'} rate={7} />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h3">Participation / Share 50%</Typography>
            <ActualBarChart strategy={'participation'} rate={0.5} />
          </Grid>

          {/* <Grid item xs={12}>
            <Typography>All Graphs</Typography>
            <ActualBarChart strategy={mode} rate={rate} />
            <Button
              onClick={() => {
                setMode('none')
                setRate('none')
              }}
            >
              Default
            </Button>

            <Button
              onClick={() => {
                setMode('capRate')
                setRate(8)
              }}
            >
              Cap Rate 8%
            </Button>

            <Button
              onClick={() => {
                setMode('fixedRate')
                setRate(5)
              }}
            >
              Fixed 5%
            </Button>

            <Button
              onClick={() => {
                setMode('trigger')
                setRate(7)
              }}
            >
              Trigger 7%
            </Button>

            <Button
              onClick={() => {
                setMode('participation')
                setRate(0.5)
              }}
            >
              50% share
            </Button>
          </Grid> */}

          <Grid item xs={12} mb={8}>
            <Typography variant="h3">No Withdrawals</Typography>
            <SequenceReturn data={[]} showHigh showLow showActual />
          </Grid>
          <Grid item xs={12} mb={8}>
            <Typography variant="h3">Showing Withdrawals</Typography>
            <SequenceReturn data={[]} withdrawals showHigh showLow showActual />
          </Grid>

          <Grid item xs={12} mb={8}>
            <Typography variant="h3">TSP Holdings</Typography>
            <NewTsp isDisplayOnly hideLabels={false}></NewTsp>
          </Grid>
          <Grid item xs={12} mb={8}>
            <Typography variant="h3">TSP Market Exposure</Typography>
            <NewTsp isDisplayOnly showExposed hideLabels={false}></NewTsp>
          </Grid>
        </Grid>
      </Box>
    </DashboardLayout>
  )
}

export default GraphsCheck
